import React, { useState, useEffect } from 'react';
import {  useNavigate, useLocation, useParams } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import  { Container, Row, Col, Button, Breadcrumb, Modal } from 'react-bootstrap';
import { GrokLoading } from '../page-layout/loading/Loading';
import { UpdateJob, CreateJob, GetUploadUrl} from '../../utils/axios/JobsAPI';
import { ROLE, ORGANIZATION_TYPE } from "../constants/constants";
import { Decrypt } from '../../utils/Helper';
import { GetOrganization } from '../../utils/axios/CompanyAPI';
import Multiselect from 'multiselect-react-dropdown';
import axios from 'axios';

const AddJob = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const editJob = location.state?.job;

    const [userInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const [loading, setLoading] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState("");
    const [initialData, setInitialData] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [errors, setErrors] = useState({ phone: "", email: "" });
    const [fileError, setFileError] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmType, setConfirmType] = useState("");

    const setLoadingState = async () => {
        setLoading(false);
    }

    const handleConfirmOpen = (type) => {
        if (type === "save") {
            const hasValidationErrors = Object.values(errors).some(msg => msg !== "");

            const isMissingRequired = !formData.title || !formData.company || !formData.phone || !formData.email;

            if (hasValidationErrors || isMissingRequired) {
                alert("Please enter correct and complete data in all fields before saving.");
                return;
            }
        }
        setConfirmType(type);
        setShowConfirm(true);
    };
   
    const handleConfirmAction = async () => {
        if (confirmType === "save") {
            setLoading(true);

            const successMessage = editJob ? "Job updated successfully!" : "Job created successfully!";

            const payload = {
                // ...formData,                
                Company: userInfo.RoleId === ROLE.GROK_ADMIN ? formData.company : userInfo.OrganizationId,
                title: formData.title,
                keyresponsiblearea: formData.keyresponsiblearea,
                location: formData.location,
                description: formData.description,
                ctc: formData.ctc,
                education: formData.education,
                experience: formData.experience,
                name: formData.name,
                phone: formData.phone,
                email: formData.email,
                CreatedBy: userInfo._id
            };

            try {

                const result = editJob
                    ? await UpdateJob(editJob._id || editJob.id, payload)
                    : await CreateJob(payload);

                if (result._id && selectedFile) {
                    try {
                        const uploadData = await GetUploadUrl(result._id, selectedFile.name);
                        console.log("Signed URL received:", uploadData.uploadUrl);

                        if (uploadData.success && uploadData.uploadUrl) {
                            // const realS3Url = Decrypt(uploadData.uploadUrl);
                            let realS3Url = "";

                            if (uploadData.uploadUrl.startsWith("http")) {
                                realS3Url = uploadData.uploadUrl;
                            } else {
                                try {
                                    realS3Url = Decrypt(uploadData.uploadUrl);
                                } catch (err) {
                                    console.error("Decryption failed. Using raw URL instead.");
                                    realS3Url = uploadData.uploadUrl;
                                }
                            }

                            console.log("Final URL for S3:", realS3Url);

                            const s3Response = await fetch(realS3Url, {
                                method: 'PUT',
                                body: selectedFile,
                                headers: {
                                    'Content-Type': selectedFile.type
                                }
                            });
                            if (!s3Response.ok) {
                                const errorText = await s3Response.text(); // S3 returns XML error details
                                console.error("AWS S3 XML Error:", errorText);
                                throw new Error(`AWS S3 rejected the file. Status: ${s3Response.status}`);
                            }
                        }
                    }
                    catch (s3Error) {
                        console.error("S3 Upload error:", s3Error);
                        alert("Job saved to database successfully, but the file upload failed to AWS.");
                        navigate('/postjob');
                        return;
                    }
                }
                else if (result && result.success === false) {
                    handleBackendValidation(result.message);
                    return;
                }
                alert(successMessage);
                navigate('/postjob');
            } catch (dbError) {
                const serverMsg = dbError.response?.data?.message || dbError.message;
                // console.error("Database save failed:", dbError);
                handleBackendValidation(serverMsg);
                alert("Failed to save: " + serverMsg);
            } finally {
                setLoading(false);
                setShowConfirm(false);
            }
        } else {
            setShowConfirm(false);
            navigate('/postjob');
        }
    };

    // Helper to map backend string to specific fields
    const handleBackendValidation = (message) => {
        const newErrors = { ...errors };
        if (message.includes("Title")) newErrors.title = "Job Title is invalid or required.";
        if (message.includes("Company")) newErrors.company = "Please select a company.";
        if (message.includes("Phone")) newErrors.phone = "Invalid phone number format.";
        if (message.includes("Email")) newErrors.email = "Invalid email format.";
        if (message.includes("Experience")) newErrors.experience = "Experience must be numeric.";

        setErrors(newErrors);
    };

    // Logic for S3 Upload
    const uploadFile = async (jobId) => {
        try {
            // Get Signed URL from Backend
            const res = await fetch(`/jobs/upload/${jobId}/${selectedFile.name}`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
            });
            const { uploadUrl } = await res.json();

            // Upload directly to S3
            await fetch(uploadUrl, {
                method: 'PUT',
                body: selectedFile,
                headers: { 'Content-Type': selectedFile.type }
            });
        } catch (err) {
            console.error("S3 Upload error:", err);
            alert("Record saved, but JD upload failed.");
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const maxSizeInBytes = 2 * 1024 * 1024;

        if (file.size > maxSizeInBytes) {
            alert("File size should not exceed the 2MB limit.");
            setSelectedFile(null);
            e.target.value = "";
        } else {
            setFileError("");
            setSelectedFile(file);
        }
    };

    const validate = (name, value) => {
        let errorMsg = "";

        if (name === "phone") {
            // Checks for exactly 10 digits
            const phoneRegex = /^[789][0-9]{9}$/;
            if (!value) {
                errorMsg = "Phone number is required.";
            } else if (!/^[0-9]+$/.test(value)) {
                errorMsg = "Only numbers are allowed.";
            } else if (value.length !== 10) {
                errorMsg = "Phone number must be exactly 10 digits.";
            } else if (!phoneRegex.test(value)) {
                errorMsg = "Please enter a valid phone number.";
            }
        }

        if (name === "email") {
            // Standard email regex
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (value && !emailRegex.test(value)) {
                errorMsg = "Please enter a valid email address.";
            }
        }

        // Job Title: Alpha-Numeric (allows spaces)
        if (name === "title") {
            const titleRegex = /^[a-zA-Z0-9\s]*$/;
            if (!titleRegex.test(value)) {
                errorMsg = "Job Title must be alpha-numeric.";
            }
        }

        // Education: Alphabetic (allows spaces and dots like B.Sc)
        if (name === "education") {
            const eduRegex = /^[a-zA-Z\s.]*$/;
            if (!eduRegex.test(value)) {
                errorMsg = "Education must contain only letters.";
            }
        }

        // Experience: Numeric
        if (name === "experience") {
            if (value && !/^\d*$/.test(value)) {
                errorMsg = "Experience must be a number.";
            }
        }

        // Location: Alphabetic
        if (name === "location") {
            const locRegex = /^[a-zA-Z\s]*$/;
            if (!locRegex.test(value)) {
                errorMsg = "Location must contain only letters.";
            }
        }

        // CTC: Numeric
        if (name === "ctc") {
            if (value && !/^\d*$/.test(value)) {
                errorMsg = "CTC must be a number.";
            }
        }
        setErrors(prev => ({ ...prev, [name]: errorMsg }));
    };

    const [formData, setFormData] = useState({
        company: "",
        title: "",
        keyresponsiblearea: "",
        location: "",
        description: "",
        ctc: "",
        education: "",
        experience: "",
        name: "",
        phone: "",
        email: "",
    });

    useEffect(() => {
        setLoadingState();

        if (editJob) {
            console.log("Editing Job:", editJob);

            const mappedData = {
                company: editJob.OrganizationId?.id || editJob.OrganizationId || editJob.company || "",
                title: editJob.title || "",
                keyresponsiblearea: editJob.keyresponsiblearea || "",
                location: editJob.location || "",
                description: editJob.description || "",
                ctc: editJob.ctc || "",
                education: editJob.education || "",
                experience: editJob.experience || "",
                name: editJob.name || "",
                phone: editJob.phone || "",
                email: editJob.email || "",
            };
            setFormData(mappedData);
            setInitialData(mappedData);
            setSelectedCompany(editJob.company || "");
        }

        else if (userInfo.RoleId === ROLE.COMPANY) {
            setFormData(prev => ({
                ...prev,
                company: userInfo.OrganizationId
            }));
        }

        const fetchCompanies = async () => {
            try {
                let organizationPayload = {};     

                const response = await GetOrganization(organizationPayload);

                if (response && response.success) {
                    let formattedCompanies = response.data.map(org => ({
                        id: org._id,
                        name: org.Name
                    }));

                    // Remove duplicate company names
                    formattedCompanies = formattedCompanies.filter((company, index, self) =>
                        index === self.findIndex((c) => c.name === company.name)
                    );

                    // Sort the dropdown alphabetically
                    formattedCompanies.sort((a, b) => a.name.localeCompare(b.name));
                    setCompanies(formattedCompanies);

                    if (userInfo.RoleId === ROLE.COMPANY) {
                        const myOrg = formattedCompanies.find(c => c.id === userInfo.OrganizationId);
                        if (myOrg) setSelectedCompany(myOrg.name);
                    }
                }
            } catch (error) {
                console.error("Error fetching companies:", error);
            }
        };

        if (userInfo.RoleId === ROLE.GROK_ADMIN || userInfo.RoleId === ROLE.COMPANY) {
            fetchCompanies();
        }
    }, [editJob, userInfo.RoleId, userInfo.OrganizationId]);

    const isSaveDisabled = () => {

        const hasChanges = editJob
            ? (JSON.stringify(formData) !== JSON.stringify(initialData) || selectedFile !== null)
            : (formData.title !== "" || formData.company !== "");

        const hasErrors = Object.values(errors).some(err => err !== "") || fileError !== "";

        const isRequiredMissing = !formData.title || !formData.company || !formData.phone || !formData.email;

        return !hasChanges || hasErrors || isRequiredMissing;
    };

    return (
    <div className='page'>
        {loading ? <GrokLoading /> : ""}

        <NavMenu />
        <Header />

        <div className='page-wrapper'>
            <Container fluid>

                {/* 🔹 Page Header */}
                <div className='page-header d-print-none'>
                    <Row className='g-2 align-items-center pb-1'>
                        <div>
                            <Breadcrumb className="custom-breadcrumb">
                                <Breadcrumb.Item onClick={() => navigate('/home')}>
                                    Home
                                </Breadcrumb.Item>
                                <Breadcrumb.Item onClick={() => navigate('/postjob')}>
                                    Job Post
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active>Add Job</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>

                        <Col style={{ display: 'flex', alignItems: 'center' }}>
                            <Button className='nave-icon' variant='outline' size='sm'>
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" width="1em" viewBox="0 -960 960 960" fill="currentColor">
                                        <path d="M160-120q-33 0-56.5-23.5T80-200v-440q0-33 23.5-56.5T160-720h160v-80q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v80h160q33 0 56.5 23.5T880-640v440q0 33-23.5 56.5T800-120H160Zm0-80h640v-440H160v440Z"/>
                                    </svg>
                                </span>
                            </Button>

                            <h2 className="page-title">  {editJob ? "Edit Job" : "Add Job"}</h2>
                        </Col>

                        <Col className="mb-1 me-3 col-md-auto">
                            <button
                                className='newBtn_style'
                                onClick={() => navigate('/postjob')}
                            >
                                ← Back
                            </button>
                        </Col>
                    </Row>
                </div>

                {/* 🔹 Form Section */}
                <div className='py-3'>

                        {/* 🔹 Form Card */}
                        <div className='card mb-3 mb-lg-5 p-4'>

                            {/* --- Job Details --- */}
                            <h5 className="mb-3">Job Details</h5>
                            <Row className="mb-3">
                                <Col md={5}>
                                    <label>Company</label>

                                    {userInfo.RoleId === ROLE.GROK_ADMIN ? (

                                    <Multiselect
                                        options={companies}
                                        isObject={true}
                                        // singleSelect={true}
                                        displayValue="name"
                                        placeholder="Select Company..."
                                        hidePlaceholder={true} // Hides placeholder when a company is selected
                                        selectedValues={companies.filter(c => c.name === selectedCompany || c.id === formData.company)}

                                        onSelect={(selectedList, selectedItem) => {
                                            setSelectedCompany(selectedItem.name);
                                            setFormData({ ...formData, company: selectedItem.id });
                                            setErrors(prev => ({ ...prev, company: "" }));
                                        }}
                                        onRemove={() => {
                                            setSelectedCompany("");
                                            setFormData({ ...formData, company: "" });
                                        }}
                                        onSearch={(value) => { }}
                                        avoidHighlightFirstOption={true}
                                        // closeIcon="circle"
                                        className="searchable-multiselect"
                                        autoComplete="off"
                                        emptyRecordMsg="No company found"
                                        style={{
                                            searchBox: {
                                                border: '1px solid #ced4da',
                                                borderRadius: '0.375rem',
                                                padding: '0.375rem 0.75rem',
                                                minHeight: '38px',
                                                // width: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexWrap: 'nowrap',
                                                backgroundColor: '#fff',
                                                position: 'relative'
                                            },
                                            inputField: {
                                                width: '100%',
                                                margin: '0',
                                                fontSize: '1rem',
                                                color: '#212529',
                                                padding: '0 5px',
                                            },
                                            chips: {
                                                background: 'transparent',
                                                color: '#212529',
                                                margin: '0',
                                                    padding: '0'
                                                }
                                            }}
                                        />
                                    ) : (
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={selectedCompany || "Loading your organization details..."}
                                            disabled
                                            style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed', fontWeight: 'bold' }}
                                        />
                                    )}
                                    {errors.company && <div className="text-danger small mt-1">{errors.company}</div>}
                                </Col>

                                <Col md={4}>
                                    <label>Job Title</label>
                                    <input className={`form-control ${errors.title ? 'is-invalid' : ''}`}
                                        value={formData.title}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/[^a-zA-Z0-9\s]/g, '');
                                            setFormData({ ...formData, title: val });
                                            validate("title", val);
                                        }}
                                    />
                                    {errors.title && <div className="invalid-feedback">{errors.title}</div>}
                                </Col>

                                <Col md={3}>
                                    <label>Key Responsible Area</label>
                                    <input className="form-control"
                                        value={formData.keyresponsiblearea}
                                        onChange={(e) =>
                                            setFormData({ ...formData, keyresponsiblearea: e.target.value })
                                        }
                                    />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={3}>
                                    <label>Education</label>
                                    <input className={`form-control ${errors.education ? 'is-invalid' : ''}`}
                                        value={formData.education}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/[^a-zA-Z\s.]/g, '');
                                            setFormData({ ...formData, education: val });
                                            validate("education", val);
                                        }}
                                    />
                                    {errors.education && <div className="invalid-feedback">{errors.education}</div>}
                                </Col>

                                <Col md={3}>
                                    <label>Experience</label>
                                    <input className={`form-control ${errors.experience ? 'is-invalid' : ''}`}
                                        value={formData.experience}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/\D/g, '');
                                            setFormData({ ...formData, experience: val });
                                            validate("experience", val);
                                        }}
                                    />
                                    {errors.experience && <div className="invalid-feedback">{errors.experience}</div>}
                                </Col>

                                <Col md={3}>
                                    <label>Location</label>
                                    <input className={`form-control ${errors.location ? 'is-invalid' : ''}`}
                                        value={formData.location}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                            setFormData({ ...formData, location: val });
                                            validate("location", val);
                                        }}
                                    />
                                    {errors.location && <div className="invalid-feedback">{errors.location}</div>}
                                </Col>

                                <Col md={3}>
                                    <label>CTC(in lacs)</label>
                                    <input className={`form-control ${errors.ctc ? 'is-invalid' : ''}`}
                                        value={formData.ctc}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/\D/g, '');
                                            setFormData({ ...formData, ctc: val });
                                            validate("ctc", val);    }}
                                    />
                                    {errors.ctc && <div className="invalid-feedback">{errors.ctc}</div>}
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={6}>
                                    <label>Description</label>
                                    <textarea className="form-control" rows="3"
                                        value={formData.description}
                                        onChange={(e) =>
                                            setFormData({ ...formData, description: e.target.value })
                                        }
                                    />
                                </Col>

                                <Col md={2}>
                                    <label>Upload JD (PDF/DOC)</label>
                                    <div className="custom-file-upload">
                                        <input
                                            type="file"
                                            id="jd-upload"
                                            accept=".pdf,.doc,.docx"
                                            style={{ display: 'none' }}
                                            onChange={handleFileChange}
                                        />
                                        <label htmlFor="jd-upload" className="form-control d-flex align-items-center justify-content-between cursor-pointer">
                                            <span className="text-truncate">
                                                {selectedFile ? selectedFile.name : "Choose file..."}
                                            </span>
                                            <i className="bi bi-cloud-arrow-up-fill text-primary" style={{ fontSize: '1.2rem' }}></i>
                                        </label>
                                    </div>

                                    {fileError && <div className="text-danger small mt-1">{fileError}</div>}

                                    <small className="text-muted">Max size: 2MB</small>
                                </Col>
                            </Row>
                        </div>

                    <div className='card mb-3 mb-lg-5 p-4'>

                        {/* --- Contact Details --- */}
                        <h5 className="mb-3">Contact Details</h5>
                        <Row className="mb-3">
                            <Col md={4}>
                                    <label>Name</label>
                                    <input className="form-control"
                                        value={formData.name}
                                        onChange={(e) =>
                                            setFormData({ ...formData, name: e.target.value })
                                        }
                                    />
                                </Col>
                                <Col md={4}>
                                    <label>Phone</label>
                                    <input
                                        className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                        value={formData.phone}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/\D/g, '');
                                            if (val.length <= 10) {
                                                setFormData({ ...formData, phone: val });
                                                validate("phone", val);
                                            }
                                        }}
                                    />
                                    {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                                </Col>
                                <Col md={4}>
                                    <label>Email</label>
                                    <input
                                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                        value={formData.email}
                                        onChange={(e) => {
                                            setFormData({ ...formData, email: e.target.value });
                                            validate("email", e.target.value);
                                        }}
                                    />
                                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                </Col>
                            </Row>
                        </div>

                        {/* 🔹 Action Buttons */}
                        <div className="d-flex justify-content-center gap-4 mt-4">
                            <button className="btn btn-success" onClick={() => handleConfirmOpen("save")} disabled={isSaveDisabled()}
                                style={{ opacity: isSaveDisabled() ? 0.6 : 1, cursor: isSaveDisabled() ? 'not-allowed' : 'pointer' }}
                            >
                                {editJob ? "Update" : "Save"}
                            </button>

                            <button className="btn btn-danger" onClick={() => handleConfirmOpen("cancel")}>
                                Cancel
                            </button>

                        </div>
                    </div>

                    <Modal
                        show={showConfirm}
                        onHide={() => setShowConfirm(false)}
                        centered
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {confirmType === "save" ? "Confirm Save" : "Confirm Cancel"}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {confirmType === "save"
                                ? `Are you sure you want to ${editJob ? 'update' : 'save'} this job post?`
                                : "Are you sure you want to cancel? Any unsaved changes will be lost."}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowConfirm(false)}>
                                No
                            </Button>
                            <Button
                                variant={confirmType === "save" ? "success" : "danger"}
                                onClick={handleConfirmAction}
                            >
                                Yes, {confirmType === "save" ? (editJob ? "Update" : "Save") : "Cancel"}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Container>

            <Footer />
        </div>
    </div>
);
};

export default AddJob;